// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { GridItemProps } from "@insite/mobius/GridItem";
import xOrderInformationStyles from "@sc/App/SharedStyles/MyAccountPages/Details/OrderInformationStyles";
import { orderInformationStyles } from "@sc/Overrides/Widgets/OrderApprovalDetails/OrderApprovalDetailsOrderInformation";
import { color, mergeWithCss } from "@sc/XDL/Utilities";
import { css } from "styled-components";

const gridSharedStyle: GridItemProps = {
    width: [12, 6, 6, 6, 6],
    css: css`
        margin-bottom: 4px;
        flex-direction: row;
    `,
};

orderInformationStyles.orderInformationGridContainer = {
    gap: 0,
    offsetCss: css`
        gap: 24px;
    `,
    css: css`
        border-bottom: 1px solid ${color("common.border")};
        &&& {
            padding-bottom: 24px;
            margin-bottom: 24px;
        }
    `,
};

orderInformationStyles.mainInformationGridContainer = {
    gap: 5,
};

orderInformationStyles.mainInformationGridItem = {
    width: 12,
    css: css`
        border-bottom: 1px solid ${color("common.border")};
        &&& {
            padding-bottom: 24px;
            @media print {
                margin-bottom: 24px;
            }
        }
    `,
};

orderInformationStyles.orderNumberTitle = {
    ...xOrderInformationStyles.labelWithDots,
};

orderInformationStyles.orderDateTitle = {
    ...xOrderInformationStyles.labelWithDots,
};

orderInformationStyles.poNumberTitle = {
    ...xOrderInformationStyles.labelWithDots,
};

orderInformationStyles.statusTitle = {
    ...xOrderInformationStyles.labelWithDots,
};

orderInformationStyles.orderNumberText = {
    ...xOrderInformationStyles.value,
};

orderInformationStyles.orderDateText = {
    ...xOrderInformationStyles.value,
};

orderInformationStyles.poNumberText = {
    ...xOrderInformationStyles.value,
};

orderInformationStyles.statusText = {
    ...xOrderInformationStyles.value,
};

orderInformationStyles.orderNumberGridItem = {
    ...gridSharedStyle,
};

orderInformationStyles.orderDateGridItem = {
    ...gridSharedStyle,
};

orderInformationStyles.poNumberGridItem = {
    ...gridSharedStyle,
};

orderInformationStyles.statusGridItem = {
    ...gridSharedStyle,
};

orderInformationStyles.shipTitle = {
    ...mergeWithCss(xOrderInformationStyles.labelWithDots, {
        css: css`
            &:after {
                content: "";
            }
        `,
    }),
};

orderInformationStyles.notesGridItem = {
    ...gridSharedStyle,
    width: 12,
};

orderInformationStyles.notesTitle = {
    ...xOrderInformationStyles.labelWithDots,
};

orderInformationStyles.notesDescription = {
    ...xOrderInformationStyles.value,
};

orderInformationStyles.orderApprovalDetailsShippingInformation = {
    shippingInformationTitle: {
        ...xOrderInformationStyles.address?.informationTitle,
    },
    shippingAddressTitle: {
        ...mergeWithCss(xOrderInformationStyles.address?.heading, {
            as: "h3",
            css: css`
                margin-bottom: 0;
            `,
        }),
    },
    shippingInformationCarrierGridItem: {
        ...gridSharedStyle,
        width: 12,
    },
    shippingInformationDateRequestedGridItem: {
        ...gridSharedStyle,
        width: 12,
    },
    shippingInformationServiceGridItem: {
        ...gridSharedStyle,
        width: 12,
    },
    shippingCarrierTitle: {
        ...xOrderInformationStyles.labelWithDots,
    },
    shippingCarrierText: {
        ...xOrderInformationStyles.value,
    },
    shippingDateRequestedTitle: {
        ...xOrderInformationStyles.labelWithDots,
    },
    shippingDateRequestedText: {
        ...xOrderInformationStyles.value,
    },
    shippingServiceTitle: {
        ...xOrderInformationStyles.labelWithDots,
    },
    shippingServiceText: {
        ...xOrderInformationStyles.value,
    },
    shippingInformationGridContainer: {
        gap: 0,
    },
    shippingOtherInformationGridContainer: {
        gap: 0,
    },
    shippingInformationAddressGridItem: {
        width: [12, 6, 6, 6, 6],
        css: css`
            flex-direction: column;
        `,
    },
    shippingOtherInformationGridItem: {
        width: [12, 6, 6, 6, 6],
    },
};

orderInformationStyles.orderApprovalDetailsBillingInformation = {
    billingInformationGridContainer: {
        gap: 0,
    },
    billingInformationTitle: {
        ...xOrderInformationStyles.address?.informationTitle,
    },
    billingAddressTitle: {
        ...mergeWithCss(xOrderInformationStyles.address?.heading, {
            as: "h3",
            css: css`
                margin-bottom: 0;
            `,
        }),
    },
    billingCreditCardAddressTitle: {
        ...mergeWithCss(xOrderInformationStyles.address?.heading, {
            as: "h3",
            css: css`
                margin-bottom: 0;
            `,
        }),
    },
};

orderInformationStyles.shippingInformationGridItem = orderInformationStyles.billingInformationGridItem = {
    width: [12, 12, 12, 5.8 as any, 5.8 as any],
    css: css`
        @media Print {
            padding-bottom: 24px;
        }
    `,
};

orderInformationStyles.spinnerWrapper = {
    css: css`
        display: flex;
        justify-content: center;
        align-items: center;
        height: 300px;
    `,
};
